import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchSlGroupsInitialData = ({
  groupType,
  groupItem,
  countryTaxType,
  includeFbosCTT,
  periodName,
} = {}) => fetch(
  Config.endpoints.FETCH_SL_GROUP_INITIAL_DATA
    .replace(/:periodName/, periodName)
    .replace(/:groupType/, groupType || '')
    .replace(/:groupItem/, groupItem || '')
    .replace(/:countryTaxType/, countryTaxType || '')
    .replace(/:includeFbosCTT/, includeFbosCTT ? 'true' : 'false')
)
  .then(handleErrors({ errorMessage: 'Fetching SL Groups initial data failed' }))
  .then(parseAsJson);

export const fetchSlGroupItems = ({ groupType, periodName }) => fetch(
  Config.endpoints.FETCH_SL_GROUP_ITEMS
    .replace(/:groupType/, groupType)
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Sl Group Items failed' }))
  .then(parseAsJson);

export const fetchTaxTypesForGroup = ({ groupType, groupItem, periodFrom }) => fetch(
  Config.endpoints.FETCH_COUNTRY_TAX_TYPES_FOR_GROUP
    .replace(/:groupType/, groupType)
    .replace(/:groupItem/, groupItem)
    .replace(/:periodName/, periodFrom)
)
  .then(handleErrors({ errorMessage: 'Fetching Tax Types for Group failed' }))
  .then(parseAsJson);

export const fetchReportDataForGroup = ({ groupType, groupItem, countryTaxType }) => fetch(
  Config.endpoints.FETCH_REPORT_DATA_FOR_GROUP
    .replace(/:groupType/, groupType)
    .replace(/:groupItem/, groupItem)
    .replace(/:countryTaxType/, countryTaxType)
)
  .then(handleErrors({ errorMessage: 'Fetching Report Data for Group failed' }))
  .then(parseAsJson);

export const fetchReportingCurrencyCodesForGroup = ({ groupType, groupItem }) => fetch(
  Config.endpoints.FETCH_REPORTING_CURRENCY_CODES_FOR_GROUP
    .replace(/:groupType/, groupType)
    .replace(/:groupItem/, groupItem)
)
  .then(handleErrors({ errorMessage: 'Fetching reporting currencies for group failed' }))
  .then(parseAsJson);
